import load from '#core/load';


const byline_selector = '.author-byline--collapsible';
const toggle_selector = '.author-byline__toggle';
const additional_selector = '.author-byline__additional';
let byline_id = 0;


const module = {

	/**
	 * Initialize collapsible author bylines.
	 */
	init() {
		if (load.ran('author-byline')) return false;

		load.content(() => {
			initialize_bylines();
		});

		window.addEventListener('reinitialize', initialize_bylines);
	},

};

export default module;
module.init();


/**
 * Progressively enhance author lists, leaving every author visible without JS.
 */
function initialize_bylines() {
	const $bylines = document.querySelectorAll(`${byline_selector}:not([data-author-byline-initialized])`);

	$bylines.forEach($byline => {
		const $toggle = $byline.querySelector(toggle_selector);
		const $additional = $byline.querySelector(additional_selector);
		if (!$toggle || !$additional) return;

		byline_id += 1;
		$additional.id = $additional.id || `author-byline-additional-${byline_id}`;
		$additional.hidden = true;
		$toggle.hidden = false;
		$toggle.setAttribute('aria-controls', $additional.id);
		$byline.setAttribute('data-author-byline-initialized', '');

		$toggle.addEventListener('click', () => {
			const is_expanded = $toggle.getAttribute('aria-expanded') === 'true';
			$toggle.setAttribute('aria-expanded', `${!is_expanded}`);
			$additional.hidden = is_expanded;
			update_toggle_text($toggle, !is_expanded);
		});
	});
}


/**
 * Keep the visible symbol and accessible control label in sync.
 *
 * @param {Element} $toggle Toggle button.
 * @param {boolean} is_expanded Current expanded state.
 */
function update_toggle_text($toggle, is_expanded) {
	const $icon = $toggle.querySelector('.author-byline__toggle-icon');
	const $label = $toggle.querySelector('.author-byline__toggle-label');
	if ($icon) {
		$icon.textContent = is_expanded ? '−' : '+';
	}
	if ($label) {
		$label.textContent = $label.textContent.trim().replace(
			is_expanded ? /^Show/ : /^Hide/,
			is_expanded ? 'Hide' : 'Show'
		);
	}
}
